import React from "react";

interface GuideProps {
  showGuide: boolean;
  title: string;
  content: React.ReactNode;
  handleClick: () => void;
  maxHeight?: string | null;
}

const GuideContentArea: React.FC<GuideProps> = ({
  showGuide = false,
  content = "",
  title = "",
  handleClick,
  maxHeight = null,
}) => {
  const maxHeightVal = (maxHeight && Number(maxHeight.split("px")[0])) || 0;
  return (
    <>
      <div
        // className="p-0 d-flex flex-column"
        className="p-0 "
        style={{
          overflow: "hidden",
          maxHeight: showGuide
            ? maxHeight
              ? `${maxHeightVal + 30}px`
              : "360px"
            : "0px",
          transition: "all 0.3s linear",
        }}
      >
        <div className="text-end pe-4">
          <i
            className="ti ti-triangle-inverted-filled fs-18 mb-1"
            style={{ fill: "#575c686b", color: "#575c686b" }}
          ></i>
        </div>
        <div
          className="card mb-0 flex-grow1 d-flex flex-column border"
          style={{ height: maxHeight ?? "320px" }}
        >
          <div className="modal-header border-bottom p-2 py-3 px-3">
            <h4>{title}</h4>
            <button
              type="button"
              className="btn-close btn-secondary custom-btn-close"
              onClick={handleClick}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="flex-grow-1 card-body py-3 overflow-y-auto ">
            {content}
          </div>
        </div>
      </div>
    </>
  );
};

export default GuideContentArea;
{
  /* <div className="text-end d-flex justify-content-end gap-1 gap-sm-2 ">
            <BackButton route={all_routes.admin_trackCase} />
            <Button
              className="border-secodary"
              onClick={() => setShowGuide((prev) => !prev)}
            >
              <i className="ti ti-info-circle-filled fs-16"></i>
              <div className="pb- ">Guide</div>
            </Button>
          </div> */
}
